import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const ParentDiv = styled.div`
    ${media.mobileDevice`
        //margin-right:16px;
        //margin-left:16px;
        padding-bottom: ${(props) => (props.paddingBottom ? props.paddingBottom : '')};;
    `}
`;
export const Heading1 = styled.span`
    margin-left: 0px;
`;
export const Heading2 = styled.span`
    margin-left: 1px;
`;
export const ImgIcon = styled.img`
    margin-right: -30px;
    ${media.mobileDevice`
    margin-right: -8px;
    `};
`;
export const ImgCont = styled.span`
    padding-top: 3px;
    cursor: pointer;
`;

export const StyledDiv = styled.div`
    justify-content: start;
    display: ${(props) => (props.display ? props.display : '')};
    ${media.mobileDevice`
    display: flex;
    justify-content: space-between;
    `};
`;

export const DesktopDiv = styled.div`
    width: ${(props) =>
        props.isIpad
            ? '50%'
            : props.desktopWidth
            ? props.desktopWidth
            : '33.33%'};
    display: ${(props) => (props.desktopDisplay ? props.desktopDisplay : '')};
    justify-content: ${(props) =>
        props.desktopJustifyContent ? props.desktopJustifyContent : ''};
    padding-bottom: ${(props) =>
        props.desktopPaddingBtm ? props.desktopPaddingBtm : '0px'};
    ${media.mobileDevice`
    width: 100%;
    display: ${(props) => (props.display ? props.display : '')};
    justify-content: ${(props) =>
        props.justifyContent ? props.justifyContent : ''};
    padding-bottom: ${(props) => (props.paddingBtm ? props.paddingBtm : '0px')};
    `};
`;

export const StyledSpan = styled.span`
    padding: 1px 18% 0 0;
    cursor: pointer;
    ${media.mobileDevice`
    padding: 3px 0 0 0;
    `};
`;

export const ErrorMsgContainer = styled.div`
    display: flex;
    width: ${(props) => (props.isIpad ? '25vw' : 'max-content;')} 
    padding-top: 0px;
    padding-left: 30px;
    align-Items: center;
    margin-top: -5px;
`;

export const WhyNotImplantedDiv = styled.div`
    display: flex;
    width: 100%;
`;

export const ImplantedAsMainRodDiv = styled.div`
    display: flex;
    align-items: flex-start;
    ${media.mobileDevice`
    padding-top: 10px;
    `};
`;

export const DisplayDiv = styled.div`
    display: flex;
    justify-content: space-between;
`;
export const BottomCardDiv = styled.div`
    display: flex;
    justify-content: space-between;
    width: ${(props) => (props.isIpad ? '94%' : '100%')};
`;
